import type { ShipmentPriceBox } from 'common/src/api/shipment-price-boxes';

export interface ShipmentPriceGroup {
  key: string;
  variety: string;
  caliber: string;
  format: string;
  weight: number | null;
  price: number;
  currency: string;
  saleDate: string;
  quantity: number;
}

const normalizeFormat = (value: string | null) => {
  const format = (value || '').trim();
  return ['', 'NA', 'N/A', 'NO ENCONTRADO'].includes(format.toUpperCase())
    ? ''
    : format;
};

/** Keep different prices, currencies and sale dates separate; never average them. */
export function summarizeShipmentPrices(boxes: ShipmentPriceBox[]) {
  const groups = new Map<string, ShipmentPriceGroup>();
  let totalQuantity = 0;
  let pricedQuantity = 0;
  for (const box of boxes) {
    const quantity = Number(box.quantity) || 0;
    totalQuantity += quantity;
    if (
      box.reported_price == null ||
      !Number.isFinite(Number(box.reported_price))
    )
      continue;
    pricedQuantity += quantity;
    const product = {
      variety: (box.labeled_variety || box.variety || '').trim(),
      caliber: (box.caliber || '').trim(),
      format: normalizeFormat(box.box_format),
      weight: box.box_weight == null ? null : Number(box.box_weight),
      price: Number(box.reported_price),
      currency: (box.reported_price_currency || '').trim(),
      saleDate: box.reported_sale_date || '',
    };
    const key = JSON.stringify(product);
    const group = groups.get(key);
    if (group) group.quantity += quantity;
    else groups.set(key, { key, ...product, quantity });
  }
  return {
    totalQuantity,
    pricedQuantity,
    pendingQuantity: totalQuantity - pricedQuantity,
    groups: [...groups.values()].sort(
      (a, b) => b.saleDate.localeCompare(a.saleDate) || b.quantity - a.quantity
    ),
  };
}
